/*global $:false */
"use strict";

/**
 * Lightbox
 */
$(document).ready(function() {
    var $portfolio = $('.portfolio'),
        portfolio_url = $portfolio.data('url'),
        $portfolio_linear = $('#portfolio-linear'),
        $portfolio_grid = $('#portfolio-grid'),
        $layout_switch = $('.layout-switch'),
        layout_state,
        $images,
        images_url = [],
        images_ratios = [],
        swiper_instance,
        lightbox_configuration,
        lightbox_instance,
        lightbox_instance_grid,
        lightbox_instance_linear;

    //  Configure Lightbox
    lightbox_configuration = {
        imageSize: 'contain',
        afterMarkup: function() {
            //  Closing
            $(document).on('keydown', function(e) {
                if (e.keyCode == 27) {
                    closeLighbox();
                }
            });
            $('.chocolat-close').on('click', closeLighbox);

            //  Insert transparent Previous - Next buttons
            $('<div class="nav-button nav-button-previous"></div>')
                .insertAfter(this.elems.content)
                .on('click', function() {
                    lightbox_instance.api().prev();
                });

            $('<div class="nav-button nav-button-next">')
                .insertAfter(this.elems.content)
                .on('click', function() {
                    lightbox_instance.api().next();
                });

            //  Insert Social links element
            this.elems.top.append($('<div id="share" class="social"></div>'));
        },
        afterPlace: function () {
            //  Move description after the image
            this.elems.content.append(this.elems.description);

            //  Change URL
            history.pushState(null, null, images_url[this.api().current()]);

            document.title = this.settings.images[this.settings.currentImage].title;
            $('meta[property="og:title"]').attr('content', this.settings.images[this.settings.currentImage].title);
            $('meta[property="og:image"]').attr('content', this.settings.images[this.settings.currentImage].src);

            if (typeof ga !== 'undefined') {
                ga('send', {
                    hitType: 'pageview',
                    page: location.pathname
                });
            }

            //  Build Social Links
            buildSocial();
        }
    };

    lightbox_instance_grid = $portfolio_grid.Chocolat(lightbox_configuration).data('chocolat');
    lightbox_instance_linear = $portfolio_linear.Chocolat(lightbox_configuration).data('chocolat');

    function buildScrollable() {
        $portfolio.addClass('swiper-container');
        swiper_instance = new Swiper('.swiper-container', {
            freeMode: true,
            freeModeSticky: false,
            slidesPerView: 'auto',
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: false
            },
        });
    }

    function destroyScrollable() {
        if (swiper_instance) {
            swiper_instance.destroy();
        }
        $portfolio.removeClass('swiper-container');
    }

    //  Switch between gallery layout (linear & grid)
    $layout_switch.on('click', function() {
        if (layout_state === 'linear') {
            setLayoutToGrid();
        } else {
            setLayoutToLinear();
        }
        
        $layout_switch.toggleClass('mode-list mode-thumb');
    });

    //  Keep track of screen size changes
    function refreshLayout() {
        if ($(window).width() < 768 && layout_state !== 'grid') {
            setLayoutToGrid();
        }

        if ($(window).width() >= 768) {
            if (layout_state !== 'linear') {
                setLayoutToLinear();
            }

            var height = $portfolio_linear.height();
            $images.each(function(idx, elt) {
                $(elt).width(height * images_ratios[idx]);
                $(elt).height(height);
            });
        }
    }
    $(window).on('resize', refreshLayout);

    $portfolio_linear
        .find('.thumb')
        .each(function(idx, elt) {
            images_url.push($(elt).data('url'));
        });

    $images = $portfolio_linear
        .find('img')
        .each(function(idx, elt) {
            images_ratios.push($(elt).data('width') / $(elt).data('height'));
        });

    $('.portfolio-grid').imagesLoaded(function() {
        refreshLayout();
    });

    function setLayoutToGrid() {
        layout_state = 'grid';

        destroyScrollable();

        $portfolio_grid.show();
        $portfolio_linear.hide();

        lightbox_instance = lightbox_instance_grid;
    }

    function setLayoutToLinear() {
        layout_state = 'linear';

        $portfolio_grid.hide();
        $portfolio_linear.show();

        lightbox_instance = lightbox_instance_linear;

        buildScrollable();
    }

    /**
     * Close Lighbox
     */
    function closeLighbox() {
        lightbox_instance.api().close();

        //  Change URL
        history.pushState(null, null, portfolio_url);
    }

    /**
     * Build Social links
     *
     * @param $element
     */
    function buildSocial() {
        $("#share").jsSocials({
            shares: [
                { share: "facebook", label: "Like", logo: "icon-facebook" },
                { share: "googleplus", label: "+1", logo: "icon-gplus" },
                { share: "pinterest", label: "Pin it", logo: "icon-pinterest" },
                { share: "twitter", label: "Tweet", logo: "icon-twitter" }
            ],
            shareIn: "popup",
            showLabel: false,
            showCount: false,
        });
    }

    //  Is there an initial photo
    if (typeof initial_photo !== 'undefined' && initial_photo != null) {
        lightbox_instance.api().open(initial_photo);
    }

    if (window.location.hash) {
        lightbox_instance.api().open(window.location.hash.replace('#', ''));
    }
});
